import actionTypes from '../actions/manage-configurable-link.actions';

const initialState = {
  entries: [],
  isLoading: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_CONFIGURABLE_LINK_REQUEST:
    case actionTypes.FETCH_CONFIGURABLE_LINK_FAILURE:
      return {
        ...state,
        isLoading: action.isLoading,
      };
    case actionTypes.FETCH_CONFIGURABLE_LINK_SUCCESS:
      return {
        ...state,
        isLoading: action.isLoading,
        entries: [...action.entries],
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/app/reducers/manage-configurable-link.reducer.js